import { component as defineComponent } from 'flightjs';
import $ from 'jquery';

function SelectDropdown() {
    this.defaultAttrs({
        select: '[data-select-dropdown-select]',
        toggle: '[data-select-dropdown-toggle]',
        list: '[data-select-dropdown-list]',
        item: '[data-select-dropdown-item]',
    });

    this.after('initialize', function () {
        this.on('click', {
            toggle: this.toggleDropdownList,
            item: this.selectItem,
        });

        this.on('change', {
            select: this.selectOption,
        });

        this.on(document, 'uiCloseSelectDropdown', this.closeDropdownList);
    });

    this.closeDropdownList = function (e, data) {
        if (!this.$node.is(data.target) && this.$node.has(data.target).length === 0) {
            this.$node.attr('data-state', 'inactive');
        }
    };

    this.toggleDropdownList = function (e) {
        e.preventDefault();
        if (this.$node.attr('data-state') === 'inactive') {
            this.$node.attr('data-state', 'active');
        } else {
            this.$node.attr('data-state', 'inactive');
        }
    };

    this.selectItem = function (e, data) {
        e.preventDefault();
        const itemContent = $(data.el).find('span').html();
        const itemValue = $(data.el).attr('data-value');

        this.select('toggle').html(itemContent);

        this.select('item').removeAttr('data-select-dropdown-selected');
        $(data.el).attr('data-select-dropdown-selected', '');

        this.$node.attr('data-state', 'inactive');

        const selectItem = this.select('select').find(`[value="${itemValue}"]`);
        selectItem.prop('selected', true);

        if (this.attr.submitParentForm) {
            this.select('select').parents('form').submit();
        }
    };

    this.selectOption = function (e, data) {
        const optionValue = data.el.options[data.el.selectedIndex].value;
        const optionContent = $(data.el.options[data.el.selectedIndex]).html();

        this.select('toggle').html(optionContent);

        this.select('item').removeAttr('data-select-dropdown-selected');
        this.select('list').find(`[data-value="${optionValue}"]`).attr('data-select-dropdown-selected', '');

        if (this.attr.submitParentForm) {
            this.select('select').parents('form').submit();
        }
    };
}

export default defineComponent(SelectDropdown);



// WEBPACK FOOTER //
// ./src/js/component_ui/select-dropdown.js